import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportsService } from '../reports.service';
import { Theme } from '../../shared/service/AutoTheme';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  public reports_types=[]
  public header={}
  public field1=[]
  public data1=[]
  public report_part:string='agent-overall-performance-current'
  public tabledata1$:BehaviorSubject<any>;
  public tabledata1:any;
  public receivedData: any;
  public datedata:any= {};
  public param: any;
  public state:boolean=true;
  tabs: any;
  filters: { tabs: any; currtab: any; };
  public currtab$ =new BehaviorSubject<any>([])
  public currtab=this.currtab$.asObservable();

  private currfilters$ =new BehaviorSubject<any>([])
  public currfilter =this.currfilters$.asObservable()
  subtabs: any;
  constructor(private router: ActivatedRoute, public data: ReportsService, public theme: Theme, private cdr: ChangeDetectorRef) {
    this.tabledata1$=new BehaviorSubject({header:{},field1:[],data1:[],report_type:''})
    this.tabledata1=this.tabledata1$.asObservable()
  }  
//    capitalize(str) {
//     return str.charAt(0).toUpperCase() + str.slice(1);
// }

//  convertToTitleCase(str) {
//     return str.split('_').join(' ');
// }
// removeDuplicates(arr, prop) {
//   return arr.filter((obj, index, self) =>
//       index === self.findIndex((t) => (
//           t[prop] === obj[prop]
//       ))
//   );
// }
  ngOnInit() {
    this.router.params.subscribe(res=>{
      console.log("param",res.id)
      let id = res.id;
      // this.maintab(id)
    //   let arr0=JSON.parse(sessionStorage.getItem('user_reports')).result[0]
    //   let reports= arr0.filter(item=>item.submodule==4 && item.module==6)
    //   console.log(reports)
    //   let mainreports=[]
    //   let innerreports=this.removeDuplicates(reports,`id`)
    //   innerreports.forEach(items=>{
    //     let obj={}
    //     let submenu=[]
       
       
    //      reports.forEach(ele=>{
         
    //       if(items.id==ele.id){
           
    //           Object.assign(obj,{title:items.title,icon:items.icon,id:items.id, class:"",
    //           label: "",
    //           labelClass: "",
    //           extralink: false})
            
    //       const convertedString =ele.report_name;
  
    //        // Prepend "report/summary/"
    //       const finalString = `report/summary/${convertedString}?id=${ele.id}`;
    //       if(ele.report_name){
    //         submenu.push({...ele,report_name:ele.report_name,path:finalString,  icon:items.icon,
    //           class: "",
    //           label: "",
    //           labelClass: "",
    //           extralink: false,
    //           submenu: []})
    //       }
  
    //       }
  
    //      })
    //      Object.assign(obj,{submenu:submenu})
    //      mainreports.push(obj)
    //   })
    //   console.log(mainreports)
    //   this.tabs=mainreports
    //   this.subtabs={tabs:this.tabs[0].submenu}
    //   this.currtab$.next([])
    //   this.currfilters$.next([])
    //  let title= this.tabs.title
    //  let id=this.tabs[0].id
    //  console.log(id,title)
    //  console.log(title)
    //  let arr1 = JSON.parse(sessionStorage.getItem('user_reports')).result[1]
    //   console.log(arr0)
    //  this.tabs = arr0.filter(item =>{
    //   console.log(item.title==title,item.report_name,title)
    //     return ( item.title==title) && item.id==id} )
    //  console.log(this.tabs)
    // this.tabChange(0)
      this.fulldata(id);
    });
  }

  fulldata(id:any){
     let arr0=JSON.parse(sessionStorage.getItem('user_reports')).result[0]
     let reports= arr0.filter(item=>item.submodule==4 && item.module==6)
     console.log(reports);
     let finalearr=[]
     switch (id) {
      case '0':{
        console.log('agent');
        reports.forEach((element:any) => {
          if(element.title=="Agents")
            finalearr.push(element);
        });
        
        break;
      }
      case '1':{
        reports.forEach((element:any) => {
          if(element.title== "Call Termination")
            finalearr.push(element);
        });
        break;
      }
      case '2':{   
        reports.forEach((element:any) => {
          if(element.title=="Live Calls")
            finalearr.push(element);
        });
        break;
      }
      case '3':{
        reports.forEach((element:any) => {
          if(element.title=="Call Center")
            finalearr.push(element);
        });
        break;
      }
      case '4':{
        reports.forEach((element:any) => {
          if(element.title=="Minute usage")
            finalearr.push(element);
        });
        break;
      }
      default:
        break;
     }
     console.log(finalearr);
     this.subtabs={tabs:finalearr};
     this.tabChange(0);
  }

  // getDetailData() {
  //   // console.log("shivamAgent::", JSON.parse(sessionStorage.getItem('user_reports')))
  //   let arr0 = JSON.parse(sessionStorage.getItem('user_reports')).result[0]
  //   let arr1 = JSON.parse(sessionStorage.getItem('user_reports')).result[1]

  //   this.tabs = arr0.filter(item => item.submodule == 3 && item.module == 2 )
  //   console.log("tabs::",this.tabs)
  // }
  tabChange(event) {
    console.log("maintab tabchange",event)
    let selectfilter = []
    let arr1 = []
    let arr2 = []
    console.log(this.subtabs);
    if (this.subtabs.tabs[event].filter) {
      arr1 = this.subtabs.tabs[event].filter.split(',')
      console.log(arr1)
      arr2 = arr1.map((item) => {
        return { filter: item.split(' ')[0], filter_type: item.split('-')[item.split('-').length - 1] }
      })
    }

    // console.log(arr2)
    let arr3 = JSON.parse(sessionStorage.getItem('user_reports')).result[1];

    arr2.forEach((item, i) => {
      selectfilter.push(...arr3.filter(ele => item.filter == ele.formname))
      selectfilter[i]['filter_type'] = item.filter_type
    })

    // console.log(selectfilter)
    this.subtabs.tabs[event]['selectfilter'] = selectfilter
    // console.log(this.tabs[event])
    // console.log(this.tabs)
    this.filters = { tabs: this.subtabs.tabs, currtab: this.subtabs.tabs[event] }
    // console.log("filters",this.subtabs.tabs[event].selectfilter)
    // console.log(this.tabs[event].selectfilter)
    console.log(this.subtabs.tabs);
    
    this.currtab$.next(this.subtabs.tabs)
    this.currfilters$.next(this.subtabs.tabs[event].selectfilter);
    console.log('subtab',this.subtabs)
    // this.cdr.detectChanges();


  }
  // maintab(event){
  //   // this.tabChange(0)
  //   console.log('maintab', event)
  //   let arr0=JSON.parse(sessionStorage.getItem('user_reports')).result[0]
  //   let reports= arr0.filter(item=>item.submodule==4 && item.module==6)
  //   // console.log(reports)
  //   let mainreports=[]
  //   let innerreports=this.removeDuplicates(reports,`id`)
  //   console.log(innerreports,'ushdna');
    
  //   innerreports.forEach(items=>{
  //     let obj={}
  //     let submenu=[]
     
     
  //      reports.forEach(ele=>{
       
  //       if(items.id==ele.id){
         
  //           Object.assign(obj,{...ele,title:items.title,icon:items.icon,id:items.id, class:"",
  //           label: "",
  //           labelClass: "",
  //           extralink: false})
          
  //       const convertedString =ele.report_name;
  //         console.log('convertedString', convertedString, ele.id)

  //        // Prepend "report/summary/"
  //       const finalString = `report/summary/${convertedString}?id=${ele.id}`;
  //       if(ele.report_name){
  //         submenu.push({...ele,report_name:ele.report_name,path:finalString,  icon:items.icon,
  //           class: "",
  //           label: "",
  //           labelClass: "",
  //           extralink: false,
  //           submenu: []})
  //       }

  //       }

  //      })
  //      Object.assign(obj,{submenu:submenu})
  //      mainreports.push(obj)
  //   })
  //   console.log(mainreports)
  //   this.tabs=mainreports
  //   this.subtabs={tabs:this.tabs[event].submenu}
  //   this.currtab$.next([])
  //   this.currfilters$.next([])
  //  let title= this.tabs.title
  //  let id=this.tabs[event].id
  // //  console.log(id,title)
  // //  console.log(title)
  //  let arr1 = JSON.parse(sessionStorage.getItem('user_reports')).result[1]
  //   // console.log(arr0)
  // //  this.tabs = arr0.filter(item =>{
  // //   console.log(item.title==title,item.report_name,title)
  // //     return ( item.title==title) && item.id==id} )
  // //  console.log(this.tabs)
  // this.tabChange(0)
  // }



}
